export const validation = {
  oldPassword: "Please enter your old password",
  newPassword: "Please enter new password",
  confirmPassword: "Please enter confirm password",
  passwordField:
    "Password should be atleast 6 to 15 character,\nOne Uppercase, One Lowercase,\nOne Number & special Character Example Special characters must be use @, #, $, %, ^, &, +, !, =",
  confirmPasswordField: "Password and Confirm Password must be the same",
};
